import EntryManager from '@wielink-application/shared/js/base/menu/EntryManager';
export default EntryManager;